// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const CaretLeftIcon = () => <Icon fitted={true} name="caret left" />;
